import ListItemIcon from "@material-ui/core/ListItemIcon";
import PlaceTwoToneIcon from "@material-ui/icons/PlaceTwoTone";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Button from "@material-ui/core/Button";
import ListItem from "@material-ui/core/ListItem";
import { useFirestore, useFirestoreDocDataOnce } from "reactfire";
import type { Game, Location } from "../common/types";
import React from "react";

function LocationListItemContent({ gameId }) {
  const firestore = useFirestore();
  const game: Game = useFirestoreDocDataOnce(
    firestore.collection("games").doc(gameId)
  );
  const location: Location = useFirestoreDocDataOnce(
    firestore.collection("locations").doc(game.locationId)
  );

  return (
    <ListItem style={{ paddingRight: 95 }}>
      <ListItemIcon>
        <PlaceTwoToneIcon />
      </ListItemIcon>
      <ListItemText
        primary={location.name}
        secondary={location.address.split(",").map((str) => (
          <span key={str.trim()}>
            {str}
            <br />
          </span>
        ))}
      />
      <ListItemSecondaryAction>
        <Button
          variant="text"
          color="secondary"
          onClick={() => {
            window.open(
              `https://www.google.de/maps/dir//${location.address.replace(
                " ",
                "+"
              )}`,
              "_blank"
            );
          }}
        >
          Anfahrt
        </Button>
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default LocationListItemContent;
